// extracted by mini-css-extract-plugin
export default {"CardsExercises_container":"CardsExercises_CardsExercises_container__Y4rak","CardsExercises_itemBox":"CardsExercises_CardsExercises_itemBox__iWfgj"};